import { render, staticRenderFns } from "./OnboardingPhotoItem.vue?vue&type=template&id=cf1e3570&"
import script from "./OnboardingPhotoItem.vue?vue&type=script&lang=js&"
export * from "./OnboardingPhotoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports